import { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';

const NotificationBell = () => {
  const [notifications, setNotifications] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const fetchNotifications = async () => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      setNotifications([]);
      return;
    }

    try {
      const response = await axios.get('https://jolyaparis.cloud/api/admin/notifications', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNotifications(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Failed to fetch notifications', error);
      // 404 means no notifications endpoint/data yet, so fallback to empty list
      if (error.response?.status === 404) {
        setNotifications([]);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  const unreadCount = notifications.filter(n => !n.is_read).length;

  const markAsRead = async (id) => {
    const token = localStorage.getItem('authToken');
    if (!token) return;

    try {
      await axios.post(`https://jolyaparis.cloud/api/admin/notifications/${id}/mark-read`, {}, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      fetchNotifications(); // refresh list
    } catch (error) {
      console.error('Failed to mark notification as read', error);
    }
  };

  return (
    <>
      <button
        onClick={() => setModalIsOpen(true)}
        style={{
          position: 'relative',
          background: 'transparent',
          border: 'none',
          fontSize: '1.5rem',
          cursor: 'pointer',
          color: '#333',
          transition: 'transform 0.2s ease-in-out',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.1)')}
        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
      >
        🔔
        {unreadCount > 0 && (
          <span
            style={{
              position: 'absolute',
              top: -5,
              right: -5,
              background: 'linear-gradient(to right, #d4145a, #fbb03b)',
              color: 'white',
              borderRadius: '50%',
              padding: '0.3rem 0.5rem',
              fontSize: '0.75rem',
              boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
              fontWeight: 'bold',
            }}
          >
            {unreadCount}
          </span>
        )}
      </button>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        style={{
          content: {
            maxWidth: '500px',
            margin: 'auto',
            padding: '2rem',
            borderRadius: '20px',
            background: '#fff',
            boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          },
          overlay: {
            backgroundColor: 'rgba(0,0,0,0.5)',
          },
        }}
      >
        <h2 style={{ marginBottom: '1rem', fontWeight: '600', fontSize: '1.5rem' }}>Notifications</h2>
        <ul style={{ listStyle: 'none', padding: 0 }}>
          {notifications.map(notif => (
            <li
              key={notif.id}
              style={{
                background: notif.is_read ? '#f4f4f4' : '#ffffff',
                borderLeft: notif.is_read ? '4px solid #ccc' : '4px solid #d4145a',
                padding: '1rem',
                borderRadius: '12px',
                marginBottom: '1rem',
                boxShadow: '0 3px 6px rgba(0,0,0,0.05)',
                transition: 'all 0.3s',
              }}
            >
              <p style={{ margin: 0, fontWeight: notif.is_read ? '400' : '600' }}>{notif.message}</p>
              <small style={{ color: '#777' }}>{new Date(notif.created_at).toLocaleString()}</small>
              {!notif.is_read && (
                <button
                  onClick={() => markAsRead(notif.id)}
                  style={{
                    display: 'block',
                    marginTop: '0.5rem',
                    background: '#d4145a',
                    color: 'white',
                    border: 'none',
                    padding: '0.4rem 0.8rem',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    fontSize: '0.85rem',
                    fontWeight: '500',
                    transition: 'background 0.3s',
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = '#b3134d')}
                  onMouseLeave={(e) => (e.currentTarget.style.background = '#d4145a')}
                >
                  Mark as Read
                </button>
              )}
            </li>
          ))}
        </ul>
      </Modal>
    </>
  );
};

export default NotificationBell;
